exports.comboChartTemplate = {
    $type: "ComboChartTile",
    style: {
        $type: "ComboChartTileStyle",
        xAxis: {
            $type: "ComboChartDimensionAxisStyle",
            // labelShown: true,
            // label: use field name
            // gridStepType: "Count",
            gridStepLabelsShown: true,
            gridStepLabelFontSize: "Small",
            gridStepLabelOrientation: "Auto",
            maxValuesInViewFixed: null,
            lineShown: true,
            gridLinesShown: false,
            maxValuesInView: "Auto",
        },
        yAxisBarDisplayType: "Classic",
        yAxisBarDataLabels: {
            $type: "DataLabelsTileStyle",
            show: false,
            position: "OutsideAbove",
            fontSize: null,
            allowOverlap: false,
        },
        yAxisLineDataLabels: {
            $type: "DataLabelsTileStyle",
            show: false,
            position: "OutsideAbove",
            fontSize: null,
            allowOverlap: false,
        },
        legendStyle: {
            legendShown: false,
            legendPosition: "Auto",
            legendTitleShown: false,
            legendTitle: "Legend",
        },
        title: {
            show: true,
            titleLocation: "Above",
        },
    },
};
